import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ALERT } from "../../../store/actions/actionTypes";
import {
  centerLogin,
  centerDashboard,
} from "../../../store/actions/centerActions/centerAuth";

export default function Login(props) {
  const dispatch = useDispatch();

  const history = useHistory();

  useEffect(() => {
    dispatch(centerDashboard());
  }, []);

  const { center } = useSelector((state) => state);

  const { centerAuth } = center;

  const [data, setData] = useState({ center_code: "", password: "" });

  const { center_code, password } = data;

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(centerLogin(data));
    dispatch({
      type: ALERT,
      payload: { loading: true },
    });
  };

  useEffect(() => {
    centerAuth.isAuth &&
      history.push(props.location.state?.from.pathname || "/center/dashboard");
  }, [centerAuth.isAuth]);
  return (
    <>
      <div className="sc-VigVT kCeVIa sc-gZMcBi jxPJzF"></div>
      <section className="logindesign">
        <div className="container">
          <div className="Formboxlogin">
            <div className="innerForm">
              <div className="Login-header">Login to your account</div>

              <form onSubmit={handleSubmit}>
                <div className="telBoxform">
                  <div className="boxlabel"></div>

                  <div className="formBox2">
                    <input
                      type="text"
                      placeholder="Enter Your Center Id*"
                      name="center_code"
                      value={center_code}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="formBox2">
                    <input
                      type="password"
                      placeholder="Password*"
                      name="password"
                      value={password}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="buttonSub">
                  <button className="btn btn-continues" type="submit">
                    Login
                  </button>
                </div>
              </form>
              <div className="Termslink mt-4">
                Forgot your password? <a href="#">Reset here</a>
              </div>
              <div className="My-help">
                Have trouble logging in? <span>Get help</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
